const styles = {
  chip: { marginBottom: '8px' },
  chipIcon: {
    fontSize: '0.9rem !important',
    marginLeft: '8px !important',
  },
};

export default styles;
